import { render, staticRenderFns } from "./Chart1.vue?vue&type=template&id=13f85a24&"
import script from "./Chart1.vue?vue&type=script&lang=js&"
export * from "./Chart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports